import withFormItemView from 'form-item-view-hoc'
import React from 'react'
import { Button, Col, Form, Icon, Input, Row, Upload } from 'antd'
import { compose } from 'recompose'
import { defaultFormItemLayout } from '../../../../../modules/FormItems'

const CustomFormItem = compose(withFormItemView)(Form.Item)

function SelectUploadForm (props) {
  const { onFileLoaded, csvFileList, transactionUploadList, beforeUpload, rfq } = props
  const { getFieldDecorator } = props.form

  const propsUpload = {
    onChange: onFileLoaded,
    beforeUpload: beforeUpload,
    fileList: csvFileList,
  }

  return (
    <Form>
      <Row>
        <Col span={12}>
          <CustomFormItem readOnly={true} {...defaultFormItemLayout} label={'RFQ'}>
            <Input value={rfq.title}/>
          </CustomFormItem>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'File'}>
            {getFieldDecorator('file', {
              rules: [{ required: true, message: 'Please Select a File!' }],
            })(
              <Upload {...propsUpload}>
                <Button>
                  <Icon type="upload"/> Select File
                </Button>
              </Upload>,
            )}
            {transactionUploadList.length > 0 && (
              <span>{`Records to be uploaded ${transactionUploadList.length}`}</span>
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

SelectUploadForm.propTypes = {}
SelectUploadForm.defaultProps = {}

export default compose(Form.create())(SelectUploadForm)
